export var ImageFillType;
(function (ImageFillType) {
    ImageFillType[ImageFillType["Image"] = 0] = "Image";
    ImageFillType[ImageFillType["Graph"] = 1] = "Graph";
})(ImageFillType || (ImageFillType = {}));
